<template>
    <div
        class="soli-round"
        :class="{
            'v-card v-sheet pa-3 white v-card--flat': errorState && dark,
            'px-4': $vuetify.breakpoint.xs && !contained,
        }"
    >
        <p class="caption red--text mx-auto" :class="{ 'my-8': !errorState }">
            {{ Object.values(errors)[0] }}
        </p>
        <SoliBtn
            type="submit"
            :text="text"
            :loading="loading"
            :gradient="
                valid ? (dark ? `${gradient}-default-shadow` : gradient) : null
            "
            block
            :plain="!valid"
            :icon="icon"
            :large="large"
            :flat="errorState || !valid"
            :disabled="disabled"
            color="soli-status-grey"
            class="font-weight-bold"
            @click="submit()"
        />
    </div>
</template>

<script>
export default {
    props: {
        dark: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Object,
            default: () => {},
        },
        gradient: {
            type: String,
            default: "gradient-orange",
        },
        icon: {
            type: String,
            default: "save",
        },
        text: {
            type: String,
            default: "Submit",
        },
        contained: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        submit() {
            this.$emit("submit");
        },
    },
    computed: {
        errorState() {
            return !!Object.values(this.errors).length;
        },
    },
};
</script>
